import type { ISerialize } from '@/objects/ISerialize';

export class ProductionEventCategory implements ISerialize {
    public ID: number;

    public Name: string | null;

    public RaceID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ID?: number; Name?: string | null; RaceID?: number }) {
        this.ID = values.ID ?? 0;

        this.Name = values.Name ?? '';

        this.RaceID = values.RaceID ?? 0;
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            ',' +
            `"RaceID": ${JSON.stringify(this.RaceID)}` +
            '}'
        );
    }

    /**
     * Creates an instance of ProductionEventCategory from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { ID?: number; Name?: string | null; RaceID?: number }): ProductionEventCategory {
        return new ProductionEventCategory(values);
    }

    public static _FromServerJson(json: any): ProductionEventCategory {
        return new ProductionEventCategory({ ID: json.ID, Name: json.Name ?? '', RaceID: json.RaceID });
    }

    /**
     * Creates an instance of ProductionEventCategory from another instance of ProductionEventCategory.
     * @param other The ProductionEventCategory you want to clone
     * @returns A cloned ProductionEventCategory
     */
    public static FromOther(other: ProductionEventCategory): ProductionEventCategory {
        return ProductionEventCategory._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ProductionEventCategory.FromOther(this);
    }

    static NAME_OF_CLASS = 'ProductionEventCategory';
}
